import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import withWidth from 'material-ui/utils/withWidth'
import {withStyles} from 'material-ui/styles/index'
import Container from '../../../common/components/Container'
import ErrorMessage from '../../../common/components/ErrorMessage'
import HeaderProgress from '../../../common/components/HeaderProgress'
import Typography from 'material-ui/Typography'
import {Panel} from '../../../components'
import {FlowSummaryLastPanelItem, FlowSummaryPanelItem} from '../../flow'
import Table, {TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow} from 'material-ui/Table'
import Paper from 'material-ui/Paper'
import moment from '../../../common/moment'

const showPrices = false

const styles = theme => ({
  topBanner: {
    marginTop: -47,
    background: `linear-gradient(135deg, ${theme.palette.gradient.start} 0%, ${theme.palette.gradient.end} 100%)`,
    textAlign: 'center',
  },
  title: {
    color: '#FFF',
    paddingTop: 30,
  },
  total: {
    color: '#FFF',
  },
  listTitle: {
    fontSize: '1.25rem',
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 4,
    paddingLeft: 0,
  },
})

const method = {
  1: 'Transferencia bancaria',
  2: 'Tarjeta de crédito',
  3: 'Tarjeta de débito',
  4: 'Efectivo',
  5: 'PagoMisCuentas',
}

const translateStatus = (id, description) => {
  switch (id) {
    case 9:
      return 'Pendiente'
    default:
      return description
  }
}

class Billing extends React.Component {

  state = {
    page: 0,
    rowsPerPage: 10,
  }

  handleChangePage = (event, page) => {
    this.setState({page})
  }

  handleChangeRowsPerPage = event => {
    this.setState({rowsPerPage: event.target.value})
  }

  renderPaymentMethod = (id) => {
    return <Typography variant="caption">{method[id] ? method[id] : ''}</Typography>
  }

  renderDate = (date) => {
    return <Typography variant="caption">{moment(date).format('LL')}</Typography>
  }

  renderStatus = (id, description) => {
    return <Typography variant="caption">{translateStatus(id, description)}</Typography>
  }

  renderTotal = (total) => {
    return <Typography variant="caption">${total.toFixed(2)}</Typography>
  }

  renderItemDescription = (item) => {
    const count = item.get('count')
    const cost = item.get('cost')
    let text = `${count} ítem${(count === 1 ? '' : 's')}`
    if (showPrices) text += ` por $${cost}/mes`
    return text
  }

  renderItemTotal = (item) => {
    const total = item.get('total').toFixed(2)
    if (showPrices) return '$' + total
    return ''
  }

  render() {
    const {classes, error, isFetching, balance, payments} = this.props
    const {rowsPerPage, page} = this.state

    if (error !== '') return <ErrorMessage error={error}/>

    let monthTotal = 0
    balance.forEach(item => {
      monthTotal += item.get('total')
    })

    return (
      <div style={{minHeight: 520}}>
        <HeaderProgress show={isFetching}/>
        <Container style={{display: isFetching === true ? 'none' : 'block'}}>
          <Typography variant="title" className={classes.listTitle} align={'center'}>Listado de ítems almacenados</Typography>
          <Panel>
            {balance.map((i, k) => (
              <FlowSummaryPanelItem
                key={i.get('id')}
                title={i.get('description')}
                description={this.renderItemDescription(i)}
                actionLabel={this.renderItemTotal(i)}
              />
            ))}
            {showPrices && (
              <FlowSummaryLastPanelItem
                rows={[{
                  label: 'Total del mes', value: `$${monthTotal.toFixed(2)}`,
                }]}
              />
            )}
          </Panel>
          <Typography variant="title" className={classes.listTitle} align={'center'}>Estado de los pagos</Typography>
          <div style={{minHeight: 200}}>
            {payments.length <= 0
              ? <Typography variant={'caption'} align={'center'}>Todavía no tienes historial de facturación</Typography>
              : (
                <Paper style={{borderRadius: 5, marginBottom: 50}}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Fecha</TableCell>
                        <TableCell>Método de pago</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell numeric>Monto</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {payments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((i, k) => {
                        const status = i.get('PaymentStatus')
                        return (
                          <TableRow key={k}>
                            <TableCell>{this.renderDate(i.get('PaymentDate'))}</TableCell>
                            <TableCell>{this.renderPaymentMethod(i.get('PaymentMethod'))}</TableCell>
                            <TableCell>{this.renderStatus(status.get('ID'), status.get('Description'))}</TableCell>
                            <TableCell numeric>{this.renderTotal(i.get('Total'))}</TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          count={payments.length}
                          onChangePage={this.handleChangePage}
                          page={page}
                          rowsPerPage={rowsPerPage}
                          onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </Paper>
              )
            }
          </div>
        </Container>
      </div>
    )
  }

  static propTypes = {
    isFetching: PropTypes.bool,
    error: PropTypes.string,
    balance: PropTypes.array.isRequired,
    payments: PropTypes.array.isRequired,
  }
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(Billing)



// WEBPACK FOOTER //
// ./src/sections/billing/components/billing.js